import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "../../style/AddTagModal.css";   

const predefinedColors = ["#9B59B6", "#E74C3C", "#2ECC71", "#F1C40F"];

const AddTagModal = ({ isOpen, onClose, onTagCreated, userId }) => {
  const [tagName, setTagName] = useState("");
  const [selectedColor, setSelectedColor] = useState("#3282B8");
  const [customColor, setCustomColor] = useState("#3282B8");
  const [useCustomColor, setUseCustomColor] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const tag_color = useCustomColor ? customColor : selectedColor;

    const res = await fetch(`${process.env.REACT_APP_API_SOURCE}/backend/api/Calendar/EventTags/add_tag.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id: userId, tag_name: tagName, tag_color }),
    });

    const data = await res.json();
    if (data.status === "success") {
      onTagCreated(); // Refresh tag list
      onClose();      // Close modal
    } else {
      alert(data.message || "Failed to add tag");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>New Category</h2>
          <CloseIcon className="close-icon" onClick={onClose} />
        </div>
        <form onSubmit={handleSubmit} className="modal-form">
          <input
            type="text"
            placeholder="Category Name"
            value={tagName}
            onChange={(e) => setTagName(e.target.value)}
            className="modal-input"
            required
          />

          <label className="tag-color-label">Pick a color:</label>
          <div className="color-swatch-group">
            {predefinedColors.map((color) => (
              <div
                key={color}
                className="color-swatch"
                style={{
                  backgroundColor: color,
                  border: selectedColor === color && !useCustomColor ? "2px solid black" : "none",
                }}
                onClick={() => {
                  setUseCustomColor(false);
                  setSelectedColor(color);
                }}
              />
            ))}
            <input
              type="color"
              value={customColor}
              onChange={(e) => {
                setUseCustomColor(true);
                setCustomColor(e.target.value);
              }}
              className="modal-color-picker"
            />
          </div>

          <button type="submit" className="modal-button">Add Category</button>
        </form>
      </div>
    </div>
  );
};

export default AddTagModal;